import { render } from "./RpmTextareaInput.vue?vue&type=template&id=ffc31ebe"
import script from "./RpmTextareaInput.vue?vue&type=script&lang=js"
export * from "./RpmTextareaInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__